import { ComponentStyleConfig } from '@chakra-ui/react';
import { colors } from '../foundations';

export const DatePicker: ComponentStyleConfig = {
  baseStyle: {
    day: {
      userSelect: 'none',
      cursor: 'pointer',
      borderRadius: '100px',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid transparent',
      _hover: {
        border: 'greyCheck',
      },
      '&[data-selected=true]': {
        border: 'blueCheck',
        bgColor: colors.purple[50],
        _hover: {
          border: 'greyCheck',
        },
        '&[data-today="true"]': {
          bgColor: colors.purple[50],
        },
      },
      '&[data-in-range=false]': {
        opacity: 0.1,
        _hover: {
          border: '1px solid transparent',
          cursor: 'auto',
        },
      },
    },
    dayLabel: {
      fontSize: 'xs',
    },
    dayWeek: {
      w: '28px',
      fontSize: '11px',
      color: colors.grey[100],
      textAlign: 'center',
    },
    month: {
      fontSize: 'md',
      fontWeight: '400',
      padding: '2px 2px',
      width: '40px',
      height: '24px',
      borderRadius: '20px',
      userSelect: 'none',
      cursor: 'pointer',
      m: '1px',
      border: '1px solid transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      _hover: {
        border: 'greyCheck',
      },
      '&[data-in-range=true]': {
        bgColor: colors.purple[50],
        border: 'blueCheck',
        _hover: {
          border: 'greyCheck',
        },
      },
    },
  },
  variants: {},
  defaultProps: {
    variant: 'flexCenter',
  },
};
